import { useField } from "remix-validated-form";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";

interface CampaignFieldProps {
  name: string;
  label: string | null;
  type?: string;
  placeholder?: string;
  required?: boolean;
  onValueChange?: (value: string) => void;
}

const CampaignField = ({
  name,
  label,
  type = "text",
  placeholder,
  required,
  onValueChange,
}: CampaignFieldProps) => {
  const { error } = useField(name);
  const { $pt } = usePrismicLabels();
  return (
    <div className="campaign-field">
      <label className="campaign-field__label" htmlFor={name}>
        {label}
        {required && <span className="campaign-field__required"> *</span>}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        className={`campaign-field__input${error ? " campaign-field__input--error" : ""}`}
        onChange={(e) => onValueChange?.(e.target.value)}
      />
      {error && (
        <span className="campaign-field__error">{$pt(error) ?? error}</span>
      )}
    </div>
  );
};

export default CampaignField;
